// @flow

import { hpfetch } from '../util';

export const submitContactForm = (fields: any) =>
  hpfetch('contact/', {
    method: 'POST',
    body: JSON.stringify(fields),
  });
